import { Box, Typography } from '@mui/material';
import { TYPE, FONT } from '../../theme/tokens';
import Reveal from './Reveal';

// ---------------------------------------------------------------------------
// Capul de secțiune: etichetă, titlu, subtitlu.
//
// Trei reguli, aceleași peste tot:
//   · eticheta e mică, colorată și scrie ce urmează, nu ce credem despre asta
//   · titlul are `text-wrap: balance` — rândurile ies egale, fără un cuvânt
//     rămas singur pe ultimul rând
//   · subtitlul se oprește la ~60 de caractere pe rând, lungimea la care
//     ochiul găsește singur rândul următor
// ---------------------------------------------------------------------------

export function Eyebrow({ children, onDark = false, sx, ...rest }) {
  return (
    <Typography
      component="p"
      sx={{
        fontFamily: FONT.mono,
        fontSize: 12,
        fontWeight: 500,
        letterSpacing: '.12em',
        textTransform: 'uppercase',
        color: onDark ? 'var(--qf-amber-mark)' : 'var(--qf-accent)',
        m: 0,
        ...sx,
      }}
      {...rest}
    >
      {children}
    </Typography>
  );
}

export default function SectionHeading({
  eyebrow,
  title,
  lede,
  align = 'left',
  onDark = false,
  component = 'h2',
  titleSx,
  sx,
  maxWidth = 720,
}) {
  const centered = align === 'center';

  return (
    <Reveal
      sx={{
        textAlign: align,
        maxWidth,
        mx: centered ? 'auto' : 0,
        ...sx,
      }}
    >
      {eyebrow && (
        <Eyebrow onDark={onDark} sx={{ mb: 2 }}>
          {eyebrow}
        </Eyebrow>
      )}

      <Typography
        component={component}
        sx={{
          ...TYPE.h2,
          color: onDark ? 'var(--qf-deep-ink)' : 'var(--qf-ink)',
          textWrap: 'balance',
          m: 0,
          ...titleSx,
        }}
      >
        {title}
      </Typography>

      {lede && (
        <Box
          component="p"
          sx={{
            ...TYPE.lede,
            mt: 2.5,
            mb: 0,
            maxWidth: '60ch',
            mx: centered ? 'auto' : 0,
            color: onDark ? 'var(--qf-deep-ink-2)' : 'var(--qf-ink-2)',
            textWrap: 'pretty',
          }}
        >
          {lede}
        </Box>
      )}
    </Reveal>
  );
}
